module.exports = __webpack_public_path__ + "media/coffee-preferences/country_of_origin_bolivia-7a263701.png";